import React from 'react';
import PropTypes  from 'prop-types';
import {connect} from 'formik';

class FieldDependentInner extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    valuesFrom = v => (v.formik || {}).values || {};

    extract() {
        const { names, formik: { form: { values } } } = this.props;
        return names.reduce((prev, current) => { prev[current] = values[current]; return prev }, {})
    }

    render() {
        return this.props.render({ values: (this.props.formik || {}).values, formik: this.props.formik })
    }

    shouldComponentUpdate(nextProps) {
        return this.props.names.some(v => this.valuesFrom(nextProps)[v] !== this.valuesFrom(this.props)[v]);
    }
}

FieldDependentInner.defaultProps = {
    fields: []
};

FieldDependentInner.propTypes = {
    names : PropTypes.arrayOf(PropTypes.string).isRequired,
    render : PropTypes.func.isRequired
};

const FieldDependent = connect(FieldDependentInner);
export {
    FieldDependent
}